import { dataStorage, DataStorageError } from '../services/dataStorage';
import { connectorSettings } from './connector-settings';
import { initHttp } from '../utils/http';
import { extendDeep, getParameterByName } from '../utils/utils';
import { toErrorObject } from '../utils/mappers';
export function connectExternalSource(adapterName, userSettings) {
  if (!(adapterName in connectorSettings)) {
    throw new Error('Invalid source');
  }
  const settings = extendDeep(connectorSettings[adapterName], userSettings);
  const http = initHttp(userSettings);
  function getParameterName() {
    return settings.parameterName;
  }
  function isConnected() {
    return dataStorage.getItem(settings.parameterName).then(result => Boolean(result), error => {
      switch (error) {
        case DataStorageError.NotFound:
        case DataStorageError.NotAllowed:
          return false;
        default:
          throw error;
      }
    });
  }
  function disconnect() {
    dataStorage.removeItem(settings.parameterName);
    return http.get(`${settings.apiUrl}${settings.disconnectPath}`, null, {
      withCredentials: true
    });
  }
  function connect() {
    window.open(`${settings.apiUrl}${settings.connectPath}?return_url=${settings.redirectUrl}`, 'connector', settings.dimensions || 'width=950,height=550');
    const promise = new Promise(function (resolve, reject) {
      window.connectService = function (data) {
        const token = getParameterByName(data, getParameterName());
        const status = getParameterByName(data, 'status');
        if (token && (!status || status !== 'FAIL')) {
          resolve(token);
        } else {
          reject(toErrorObject({
            code: 401,
            message: 'Not Authorized'
          }));
        }
      };
    });
    promise.then(function (token) {
      return dataStorage.setItem(settings.parameterName, token);
    }, function (reason) {
      return reason;
    });
    return promise;
  }
  return {
    connect,
    disconnect,
    isConnected
  };
}